import { useEffect, useRef, useState } from 'react';

import { CSVLink } from 'react-csv';
import Footer from 'src/ui-bloom/components/Footer';
import PageHeader from './PageHeader';

import { Grid } from '@mui/material';
import PageTitleWrapper from 'src/ui-bloom/components/PageTitleWrapper';

import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import ErrorPanel from 'src/components/error-panel';
import { getContacts } from 'src/services/query-client';
import Results from './Results';

function ContactList() {
  const { enqueueSnackbar } = useSnackbar();
  const [isExportClicked, setIsExportClicked] = useState(false);
  const [teamDataRefreshTriggerId, setTeamDataRefreshTriggerId] = useState('');
  const refLink = useRef(null);

  const {
    data: { data: contacts = [] } = {},
    isError,
    error,
    isLoading,
    refetch
  } = useQuery('contacts', getContacts);

  const onRefreshData = () => {
    setTeamDataRefreshTriggerId(Date.now() + '');
  };

  const handleExportContacts = () => {
    refLink.current?.link?.click();
  };

  useEffect(() => {}, []);

  return (
    <>
      <PageTitleWrapper>
        <PageHeader
          handleExportContacts={handleExportContacts}
          refreshData={onRefreshData}
        />

        <CSVLink
          ref={refLink}
          data={contacts}
          filename={'contacts.csv'}
          headers={[
            {
              key: 'fullName',
              label: 'fullName'
            },
            {
              key: 'email',
              label: 'email'
            },
            {
              key: 'descriptionRich',
              label: 'descriptionRich'
            },
            {
              key: 'contactNumber',
              label: 'contactNumber'
            }
          ]}
        />
      </PageTitleWrapper>

      <Grid
        sx={{
          px: 4
        }}
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item xs={12}>
          {isError && (
            <ErrorPanel
              title="failed to load data"
              message={JSON.stringify(error)}
            />
          )}
        </Grid>

        <Grid item xs={12}>
          <Results
            contacts={contacts}
            isLoading={isLoading}
            onDeleteSuccess={() => refetch()}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
}

export default ContactList;
